import { render, staticRenderFns } from "./emptyContent.vue?vue&type=template&id=d3072a52&scoped=true"
import script from "./emptyContent.vue?vue&type=script&lang=js"
export * from "./emptyContent.vue?vue&type=script&lang=js"
import style0 from "./emptyContent.vue?vue&type=style&index=0&id=d3072a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3072a52",
  null
  
)

export default component.exports